const runtime = window.RUNTIME_CONFIG ?? {};

export const config = {
  CLABS_API_URL: runtime.CLABS_API_URL ?? "http://localhost:8080",
  COGNITO_USER_POOL_ID: runtime.COGNITO_USER_POOL_ID ?? "us-east-2_avoOS0oEc",
  COGNITO_CLIENT_ID: runtime.COGNITO_CLIENT_ID ?? "5p3o5uj9o9oqc2sn6r53ig8cik",
  COGNITO_REGION: runtime.COGNITO_REGION ?? "us-east-2",
  COGNITO_DOMAIN: runtime.COGNITO_DOMAIN ?? "us-east-2avoos0oec.auth.us-east-2.amazoncognito.com"
}